import React from 'react'
import MaterialReactTable from 'material-react-table'
import { MRT_Localization_ES } from 'material-react-table/locales/es'
import Button from '../Button'
import { CsvBuilder } from 'filefy'
import { AiOutlineFileExcel, AiOutlineFilePdf } from 'react-icons/ai'
import styled from 'styled-components'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import printjs from 'print-js'
import { Link } from 'react-router-dom'
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { getAll, deleted } from '../../actions'
import { connect } from 'react-redux'
import { AiOutlineCloudUpload } from 'react-icons/ai'
import * as XLSX from 'xlsx'
import formatNumbers from '../../utils/formatNumbers'

pdfMake.vfs = pdfFonts.vfs || pdfFonts.default?.vfs || pdfFonts.pdfMake?.vfs;

const Table = props => {
  const {
    data,
    columns,
    grouping = [],
    nameFile = 'exportado',
    exportButton = true,
    masiveCharge = false,
    dataForMasiveCharge = {},
    showColumnFilters = true,
    pinning = {},
    pdf = false,
    reportPdf,
    reportTitle,
    crud = false,
    path = '',
    actionAfterDelete,
    deleted,
    getAll,
    columnVisibility = {},
  } = props

  const exportCsv = allData => {
    const exportedData = allData.map(rowData => {
      return columns
        .filter(columnDef => columnDef.export !== false)
        .map(columnDef => {
          return rowData[columnDef.accessorKey]
        })
    })
    new CsvBuilder(nameFile)
      .setDelimeter(',')
      .setColumns(
        columns
          .filter(columnDef => columnDef.export !== false)
          .map(columnDef => columnDef.header)
      )
      .addRows(exportedData)
      .exportFile()
  }

  const handleExportRows = rows => {
    exportCsv(rows.map(row => row.original))
  }

  const handleExportRowsPdf = async (rows, output = 'print') => {
    const data = rows.map(row => row.original)
    return new Promise((resolve, reject) => {
      // Define el contenido del PDF
      const documentDefinition = reportPdf(data, reportTitle)

      if (output === 'b64') {
        //SI INDICAMOS QUE LA SALIDA SERA [b64] Base64
        const pdfMakeCreatePdf = pdfMake.createPdf(documentDefinition)
        pdfMakeCreatePdf.getBase64(data => {
          resolve({
            success: true,
            content: data,
            message: 'Archivo generado correctamente.',
          })
        })
        return
      }

      //ENVIAR A IMPRESIÓN DIRECTA
      if (output === 'print') {
        const pdfMakeCreatePdf = pdfMake.createPdf(documentDefinition)
        pdfMakeCreatePdf.getBase64(data => {
          printjs({
            printable: data,
            type: 'pdf',
            base64: true,
          })
          resolve({
            success: true,
            content: null,
            message: 'Documento enviado a impresión.',
          })
        })
        return
      }

      reject({
        success: false,
        content: null,
        message: 'Debes enviar tipo salida.',
      })
    })
  }

  const handleDelete = id => {
    console.log(
      '🦙 ~ file: index.jsx:102 ~ handleDelete ~ id:',
      id,
      path
    )
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¡No podrás revertir esto!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '¡Sí, bórralo!',
    }).then(result => {
      if (result.value) {
        deleted(`${path}/${id}`, 'DELETED').then(() => {
          getAll(path, actionAfterDelete)
        })
        Swal.fire(
          '¡Eliminado!',
          'El registro ha sido eliminado.',
          'success'
        )
      }
    })
  }

  if (
    crud === true &&
    columns.find(column => column.header === 'Acciones') === undefined
  ) {
    columns.push({
      header: 'Acciones',
      accessorKey: 'id',
      export: false,
      Cell: ({ cell }) => (
        <>
          <Link to={`/${path}/${cell.getValue()}`}>
            <Button color="warning">
              <AiOutlineEdit />
            </Button>
          </Link>
          <Button
            color="danger"
            onClick={() => handleDelete(cell.getValue())}
          >
            <AiOutlineDelete />
          </Button>
        </>
      ),
    })
  }

  const handleFileChange = event => {
    if (!event.target.files.length) {
      return
    }
    const file = event.target.files[0]
    const schema = dataForMasiveCharge.columns

    try {
      const reader = new FileReader()
      reader.onload = async e => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const jsonData = XLSX.utils.sheet_to_json(worksheet)

        // Convertir los datos a un formato según el esquema
        const formattedData = jsonData.map(row => {
          const mappedRow = {}
          Object.keys(schema).forEach(key => {
            mappedRow[schema[key]] = row[key] || null
          })
          return mappedRow
        })

        console.log(
          '🦙 ~ file: index.jsx:187 ~ formattedData ~ formattedData:',
          formattedData
        )
      }

      reader.readAsArrayBuffer(file)
    } catch (error) {}
  }

  const columnsProssesed = columns.map(column => {
    if (column.money !== true) {
      return column
    }
    return {
      ...column,
      Cell: ({ cell }) => `$${formatNumbers(cell.getValue(), 2)}`,
    }
  })

  return (
    <Container>
      <MaterialReactTable
        columns={columnsProssesed}
        data={data}
        enableColumnFilterModes
        enableColumnOrdering
        enableGrouping
        enablePinning
        enableStickyHeader
        positionToolbarAlertBanner="bottom"
        localization={MRT_Localization_ES}
        initialState={{
          density: 'compact',
          grouping: grouping,
          showColumnFilters: showColumnFilters,
          columnPinning: pinning,
          columnVisibility: columnVisibility,
        }}
        renderTopToolbarCustomActions={({ table }) => (
          <ButtonContainer>
            {exportButton === true && (
              <>
                <Button
                  color="primary"
                  style={{ display: 'flex', alignItems: 'center' }}
                  onClick={() =>
                    handleExportRows(
                      table.getPrePaginationRowModel().rows
                    )
                  }
                >
                  <span style={{ marginRight: '5px' }}>
                    Exportar XLSX
                  </span>
                  <AiOutlineFileExcel />
                </Button>

                {pdf === true && (
                  <Button
                    color="danger"
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() =>
                      handleExportRowsPdf(
                        table.getPrePaginationRowModel().rows,
                        'print'
                      )
                    }
                  >
                    <span style={{ marginRight: '5px' }}>
                      Imprimir PDF
                    </span>
                    <AiOutlineFilePdf />
                  </Button>
                )}
              </>
            )}
            {masiveCharge === true && (
              <>
                <FileInputWrapper>
                  <FileButton>
                    Carga Masiva
                    <FileIcon>
                      <AiOutlineCloudUpload />
                    </FileIcon>
                  </FileButton>
                  <HiddenFileInput
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                  />
                </FileInputWrapper>
              </>
            )}
          </ButtonContainer>
        )}
      />
    </Container>
  )
}

const mapDispatchToProps = {
  getAll,
  deleted,
}

export default connect(null, mapDispatchToProps)(Table)

const Container = styled.div`
  max-width: calc(100vw - 340px);
`

const ButtonContainer = styled.div`
  display: flex;
`

const FileInputWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const FileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: ${props => props.theme.primary};
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 100%;
  &:hover {
    background-color: #0056b3;
  }
`

const FileIcon = styled.span`
  font-size: 18px;
  display: flex;
  align-items: center;
`

const HiddenFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`
